import { EPageType } from 'detailsv2/LandingV2/Page/types';

import { CommonModalData, IContentPage } from '../types';

export { EPageType };

export type DetailsSceneProps = {
  modalData: CommonModalData;
  type: 'default' | 'primary' | 'secondary' | 'property' | 'area';
  initialType?: EPageType;
  isOneOffCloseModal?: boolean;
  withoutOneOff?: boolean;
};

export type DefaultFormValues = {
  id?: string | number;
  name: string;
  tags: string[];
};

type AreaFieldValues = {
  id: IContentPage['areaId'];
  name: IContentPage['areaName'];
  pageStatus?: IContentPage['areaPageStatus'];
  confirmed?: boolean;
};

export type PropertyFormValues = {
  type: EPageType.PROPERTY;
  address?: string;
  coords?: string;
  countryId?: string;
  area?: AreaFieldValues | null;
  masterProperty?: {
    id?: string | number | null;
    name?: string | null;
  };
  portfolio?: string;
} & DefaultFormValues;

export type AreaFormValues = {
  type: EPageType.AREA;
  address?: string;
  coords?: string;
  countryId?: string;
} & DefaultFormValues;

export type AboutUsFormValues = {
  type: EPageType.ABOUT_US;
  emergencyContact: {
    email: string;
    name: string;
    phone: string;
  };
} & DefaultFormValues;

export type ActivityFormValues = {
  type: EPageType.ACTIVITY;
  countryId?: string;
  area?: AreaFieldValues | null;
} & DefaultFormValues;

export type MiscFormValues = {
  type: EPageType.MISC;
} & DefaultFormValues;

export type IntroNotesFormValues = {
  type: EPageType.ABOUT_SAFARI;
} & DefaultFormValues;

export type PreTravelInfoFormValues = {
  type: EPageType.PRE_TRAVEL_INFO;
} & DefaultFormValues;

export type CommonFormValues = MiscFormValues | IntroNotesFormValues | PreTravelInfoFormValues;

export type FormValues =
  | AreaFormValues
  | MiscFormValues
  | IntroNotesFormValues
  | PreTravelInfoFormValues
  | ActivityFormValues
  | AboutUsFormValues
  | PropertyFormValues;
